import { Component, DestroyRef, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Config } from '@cbcore/services/config/config.service';
import { TranslationService } from '@cbcore/services/translation/translation.service';
import { TranslocoService } from '@jsverse/transloco';

const LANGUAGE_NATIVE_NAMES: Record<string, string> = {
  'en':      'English',
  'zh-CN':   '中文(简体)',
  'zh-TW':   '中文(繁體)',
  'ja':      '日本語',
  'ko-KR':   '한국어',
  'id-ID':   'Bahasa Indonesia',
  'th-TH':   'ภาษาไทย',
  'vi-VN':   'Tiếng Việt',
  'fr':      'Français',
  'pt':      'Português',
  'es':      'Español',
  'cs':      'Čeština',
  'ru':      'Русский',
  'tr':      'Türkçe',
  'hy':      'Հայերեն',
  'de':      'Deutsch',
  'fi':      'Suomi',
  'hu':      'Magyar',
  'nb':      'Norsk',
  'pl':      'Polski',
  'sv':      'Svenska',
  'ge':      'ქართული',
  'pt-BR':   'Português (Brasil)',
  'en-NL':   'English (NL)',
  'nl':      'Nederlands',
  'fr-BE':   'Français (Belgique)',
  'el':      'Ελληνικά',
  'uk-UA':   'Українська',
  'es-CO':   'Español (Colombia)',
  'es-PE':   'Español (Perú)',
  'et':      'Eesti',
  'am':      'አማርኛ',
  'es-MX':   'Español (México)',
};

@Component({
  selector: 'language-switcher',
  templateUrl: './language-switcher.html',
  styleUrl: './language-switcher.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export class LanguageSwitcherComponent {
  private config = inject(Config);
  private translationService = inject(TranslationService);
  private translocoService = inject(TranslocoService);
  private destroyRef = inject(DestroyRef);

  readonly activeLang = signal<string>(this.translationService.getLanguage());

  readonly languages: { code: string; label: string }[] =
    (this.config.CONFIG.supportedLanguages ?? []).map((code: string) => ({
      code,
      label: LANGUAGE_NATIVE_NAMES[code] ?? code
    }));

  constructor() {
    this.translocoService.langChanges$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(lang => this.activeLang.set(lang));
  }

  selectLanguage(event: Event): void {
    const lang = (event.target as HTMLSelectElement).value;
    this.translationService.setLanguage(lang);
  }
}
